import Availability from 'MeetingsBase/models/Availability';
import { AVAILABILITY_OPTIONS } from 'MeetingsBase/constants/dates';
function toMilliseconds(availability) {
  const result = {};
  const keys = Object.keys(AVAILABILITY_OPTIONS);
  for (const key of keys) {
    result[key] = (availability[key] || []).map(timeRange => timeRange.toMilliseconds());
  }
  return result;
}
export default class AvailabilityMilliseconds extends Availability {
  static from(data) {
    if (!data || Object.keys(data).length === 0) {
      return new AvailabilityMilliseconds(super.from(data));
    }
    return this.fromAvailability(Availability.from(data));
  }
  static fromAvailability(availability) {
    if (!availability || Object.keys(availability).length === 0) {
      return new AvailabilityMilliseconds();
    }
    const availabilityInMilliseconds = toMilliseconds(availability);
    return new AvailabilityMilliseconds(availabilityInMilliseconds);
  }
}